import { render, staticRenderFns } from "./ElColorableInput.vue?vue&type=template&id=e506d182"
import script from "./ElColorableInput.vue?vue&type=script&lang=js"
export * from "./ElColorableInput.vue?vue&type=script&lang=js"
import style0 from "./ElColorableInput.vue?vue&type=style&index=0&id=e506d182&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports